<div class="ui-autocomplete">
  <input
    type="text"
    [class]="inputClass"
    [matAutocomplete]="auto"
    [value]="displayValue"
    [placeholder]="placeholder"
    [disabled]="disabled"
    [ngClass]="{
      error: control?.invalid,
    }"
    (input)="onInputChange($event)"
    (focus)="onFocus($event)"
  />
  <mat-autocomplete
    #auto="matAutocomplete"
    [displayWith]="displayFn"
    (optionSelected)="onSelectChange($event)"
    lumInfiniteScroll
    (lumInfiniteScroll)="scrollPaginate.emit(true)"
  >
    <ng-container *ngIf="scrollPaginateEnabled">
      <ng-container *ngFor="let option of options; trackBy: trackById">
        <mat-option [value]="option">
          {{ option[displayProperty] }}
        </mat-option>
      </ng-container>
      <ng-container
        *ngIf="displayNoResults && !options.length && !(loading$ | async)"
      >
        <mat-option> No records found </mat-option>
      </ng-container>
      <ng-container *ngIf="loading$ | async">
        <ng-template [ngTemplateOutlet]="loadingTemplate"></ng-template>
      </ng-container>
    </ng-container>

    <ng-container *ngIf="!scrollPaginateEnabled">
      <ng-container *ngIf="!((loading$ | async) || loading); else loader">
        <ng-container *ngFor="let option of options">
          <mat-option [value]="option">
            {{ option[displayProperty] }}
          </mat-option>
        </ng-container>
        <ng-container *ngIf="displayNoResults && !options.length">
          <mat-option> No records found </mat-option>
        </ng-container>
      </ng-container>
      <ng-template #loader>
        <ng-template [ngTemplateOutlet]="loadingTemplate"></ng-template>
      </ng-template>
    </ng-container>

    <ng-template #loadingTemplate>
      <mat-option>
        <div class="flex gap-4">
          <mat-progress-spinner
            class="progress-spinner mt-3"
            diameter="24"
            mode="indeterminate"
          ></mat-progress-spinner>
          <small>Loading...</small>
        </div>
      </mat-option>
    </ng-template>
  </mat-autocomplete>
</div>
